import React from "react";
import { WorkspaceSelectionProvider } from "../hooks/useWorkspaceSelection";

/**
 * Mounts the selection context so that a page component can call
 * `useWorkspaceSelection` in the same render that later produces a
 * `WorkspaceShell` below.
 *
 * Drag-and-drop is handled by the app-wide `TransferDndProvider` in
 * `WorkspaceLayout`; this provider only supplies selection state.
 *
 * `FileConflictResolverProvider` used to be mounted here too, but it now
 * lives at `CohesiveLayout` level so chat and canvas uploads can call into
 * the same dialog without each surface re-mounting it.
 */
export function WorkspaceProviders({
  children,
}: {
  children: React.ReactNode;
}) {
  return <WorkspaceSelectionProvider>{children}</WorkspaceSelectionProvider>;
}
